import { isDisabledIdeaState } from '@/enums/management-input.enum.ts'

export interface FillingProgressDisplay {
  percent: number
  isDisabled: boolean
  isOrderCanceled: boolean
  isFilled: boolean
  useDisabledStyle: boolean
  isComplete: boolean
  displayPercent: string
}

/**
 * Extract and compute filling progress display logic from component props.
 * Handles NaN protection, disabled state, filled (but <100%) orders, and display formatting.
 */
export function getFillingProgressDisplay(
  value: number | null | undefined,
  ideaState: string | null | undefined,
  orderState?: string | null,
  isOrderRow: boolean = false
): FillingProgressDisplay | null {
  const percent = (value ?? 0) * 100

  if (typeof percent !== 'number' || !Number.isFinite(percent)) {
    return null
  }

  const isDisabled = isDisabledIdeaState(ideaState)
  // Order rows whose own state is "Canceled" get the same greyed-out styling
  const isOrderCanceled = isOrderRow && orderState === 'Canceled'
  // Order rows whose own state is "Filled" but haven't reached 100% get the
  // same greyed-out styling as disabled ideas.
  const isFilled = isOrderRow && orderState === 'Filled' && percent < 100
  const useDisabledStyle = isDisabled || isOrderCanceled || isFilled
  const isComplete = percent >= 100 && !isDisabled
  const displayPercent = `${Math.round(percent * 10) / 10}%`

  return {
    percent,
    isDisabled,
    isOrderCanceled,
    isFilled,
    useDisabledStyle,
    isComplete,
    displayPercent,
  }
}
